// Dash-wide "game detail view" affordance (Dan, Jul 2026). The pattern:
// clicking a game/event row or card opens the in-page order screen (buy
// panel) on the right; THIS icon is the separate, explicit path to the
// /game/... detail page. Render it only when the caller resolved an href —
// absence means no detail page exists for the market, so the icon doubles
// as the "a detail view exists" indicator.
//
// Same-page navigation on purpose: a popped tab is another live-feed
// consumer (orderbook subscriptions on top of the shared feed —
// backpressure), so the default click stays in-page. Ctrl/Cmd/middle-click
// on the underlying <Link> still opens a tab when the trader really wants
// one.

import type { MouseEvent } from 'react';
import { Link } from 'react-router-dom';
import { ChartNoAxesCombined } from 'lucide-react';

export function GameDetailLink({
  href,
  size = 12,
  className = '',
}: {
  href: string;
  size?: number;
  className?: string;
}) {
  return (
    <Link
      to={href}
      // Hosts are click-to-open-order-panel rows/cards — never let this
      // bubble into that handler.
      onClick={(e: MouseEvent) => e.stopPropagation()}
      title="Open game detail view"
      aria-label="Open game detail view"
      className={`text-muted-foreground inline-flex shrink-0 items-center rounded p-1 align-middle transition-colors hover:bg-blue-500/10 hover:text-blue-400 ${className}`}
    >
      <ChartNoAxesCombined size={size} />
    </Link>
  );
}
